/**------------------------------------------------------
 * Marketplace Definitions
 */
export enum EnumMbaMarketplace {
	COM 		= 'com',
	CO_UK 		= 'co_uk',
	DE 			= 'de',
	FR 			= 'fr',
	IT 			= 'it',
	ES 			= 'es',
	JP 			= 'jp'
}


/**------------------------------------------------------
 * Product Definitions
 */
export enum EnumMbaProduct {
	StandardShirt 					= 'standard_shirt',
	PremiumShirt 					= 'premium_shirt',
	ComfortColorsHeavyweightTShirt 	= 'comfort_colors_heavyweight_tshirt',
	VNeckShirt 						= 'vneck_shirt',
	TankTop 						= 'tank_top',
	LongSleeveShirt 				= 'long_sleeve_shirt',
	BaseballJersey 					= 'baseball_jersey',
	BasketballJersey				= 'basketball_jersey',
	SoccerJersey					= 'soccer_jersey',
	Raglan 							= 'raglan',
	Sweatshirt 						= 'sweatshirt',
	ComfortColorsSweatshirt 		= 'comfort_colors_sweatshirt',
	ComfortColorsCropSweatshirt		= 'comfort_colors_crop_sweatshirt',
	CropTop							= 'crop_top',
	PulloverHoodie 					= 'pullover_hoodie',
	ZipHoodie 						= 'zip_hoodie',
	PerformanceHoodie				= 'performance_hoodie',
	PerformanceShirt 				= 'performance_shirt',
	PerformancePolo 				= 'performance_polo',
	PerformanceQuarterZip 			= 'performance_quarter_zip',
	SoftshellJacket					= 'softshell_jacket',
	PopSockets 						= 'popsockets',
	IPhoneCases 					= 'iphone_cases',
	SamsungCases 					= 'samsung_cases',
	CrossbodyBag					= 'crossbody_bag',
	ToteBag 						= 'tote_bag',
	ThrowPillows 					= 'throw_pillows',
	Tumbler 						= 'tumbler',
	CeramicMug 						= 'ceramic_mug',
	WaterBottle 					= 'water_bottle',
	BaseballHat 					= 'printed_baseball_hat',
	TruckerHat 						= 'printed_trucker_hat',
	SportSunVisor 					= 'sport_sun_visor',
	SportBackpack					= 'sport_backpack',
	HardcoverJournal				= 'hardcover_journal',
	ValueGraphicTShirt 				= 'value_graphic_tshirt',
	LaptopSleeve					= 'laptop_sleeve',
	MousePad						= 'mouse_pad',
	ThrowBlanket 					= 'throw_blanket',
	UnframedPoster					= 'unframed_poster',
	TravelTumbler 					= 'travel_tumbler',
	RetractablePen 					= 'retractable_pen'
}


/**------------------------------------------------------
 * Listing Definitions
 */
export enum EnumMbaProductType {
	Clothing  	= 'clothing',
	Accessory 	= 'accessory'
}

export enum EnumMbaScalingType {
	Default		= 'default',
	Special		= 'special'
}

export enum EnumMbaPrint {
	Front  		= 'front',
	Back 		= 'back',
	FrontPanel	= 'front_panel',
	FrontPocket	= 'front_pocket',
	FrontPrint	= 'option_front',
	BackPrint	= 'option_back'
}

export enum EnumMbaFitType {
	Men  		= 'men',
	Women 		= 'women',
	Youth		= 'youth',
	Girls 		= 'girls',
	AdultUnisex	= 'adultunisex' // TODO: (Seshu) Add to spell check
}

export enum EnumMbaAvailability {
	Public 		= 'public',
	Private		= 'private'
}

export enum EnumMbaPublish {
	Live  		= 'live',
	Draft		= 'draft'
}


/**------------------------------------------------------
 * Color Definitions
 */
export enum EnumMbaColor {
	NoColor				= 'no_color',
	Asphalt				= 'asphalt',
	BabyBlue			= 'baby_blue',
	DeepBlue			= 'deep_blue',
	Black				= 'black',
	Brown				= 'brown',
	Cranberry			= 'cranberry',
	DarkHeather			= 'dark_heather',
	ForestGreen			= 'forest_green',
	Grass				= 'grass',
	HeatherBlue			= 'heather_blue',
	Grey				= 'grey',
	DarkGrey			= 'dark_grey',
	HeatherGrey			= 'heather_grey',
	GreyTieDye			= 'grey_tie_dye',
	KellyGreen			= 'kelly_green',
	KellyGreenWhite		= 'kelly_green_white',
	Lemon				= 'lemon',
	Navy				= 'navy',
	Olive				= 'olive',
	Orange				= 'orange',
	OrangeWhite			= 'orange_white',
	Pink				= 'pink',
	Lilac				= 'lilac',
	Plum				= 'plum',
	NeonPink			= 'neon_pink',
	Purple				= 'purple',
	PurpleTieDye		= 'purple_tie_dye',
	Red					= 'red',
	RaspberryRed		= 'raspberry_red',
	Sapphire			= 'sapphire',
	Royal				= 'royal',
	Silver				= 'silver',
	Stone				= 'stone',
	Slate				= 'slate',
	White				= 'white',
	WhiteWhite			= 'white_white',
	MaroonWhite			= 'maroon_white',
	Beige				= 'beige',
	BlackAthleticHeather = 'black_athletic_heather',
	BlackWhite			= 'black_white',
	DarkHeatherWhite 	= 'dark_heather_white',
	NavyAthleticHeather	= 'navy_athletic_heather',
	NavyWhite			= 'navy_white',
	RedWhite			= 'red_white',
	RedWhiteRoyal 		= 'red_white_royal',
	RoyalBlueWhite		= 'royal_blue_white',
	DarkGreen 			= 'dark_green',
	Burgundy 			= 'burgundy',
	GoldenYellow 		= 'golden_yellow',
	YellowWhite 		= 'yellow_white',
	PurpleHeather 		= 'purple_heather',
	RedHeather 			= 'red_heather',
	OliveHeather 		= 'olive_heather',
	PinkHeather 		= 'pink_heather',
	SageGreen 			= 'sage_green',
	BrightPink 			= 'bright_pink',
	PinkWhite 			= 'pink_white',
	DustyBlue 			= 'dusty_blue',
	BlueTieDye			= 'blue_tie_dye',
	BrushedSteel 		= 'brushed_steel',
	BlueWhite 			= 'blue_white',
	LightBlue			= 'light_blue',
	Mauve				= 'mauve',
	Storm				= 'storm',
	Tan					= 'tan',
	Forest 				= 'forest',
	Ivory				= 'ivory',
	LightBeige			= 'light_beige',
	LightPink			= 'light_pink',
	LightPurple			= 'light_purple',
	MintGreen			= 'mint_green',
	Khaki				= 'khaki',
	CamoGreen			= 'camo_green',
	FernTieDye			= 'fern_tie_dye',
	UmberTieDye			= 'umber_tie_dye',
	NavyBlue			= 'navy_blue',
	RoyalBlue			= 'royal_blue',
	Pepper				= 'pepper',
	BlueJean			= 'blue_jean',
	LightGreen			= 'light_green',
	Crimson				= 'crimson',
	Orchid				= 'orchid',
	Espresso			= 'espresso',
	RoseQuartz			= 'rose_quartz',
	Dusk 				= 'dusk',
	Chambray			= 'chambray',
	SlateGrey			= 'slate_grey',
	SlateGreyWhite		= 'slate_grey_white',
	AsphaltGrey			= 'asphalt_grey',
	DarkBlueWhite		= 'dark_blue_white',
	DarkGreenWhite		= 'dark_green_white',
	GreenWhite			= 'green_white',
	PurpleWhite			= 'purple_white',
	WhiteBlack			= 'white_black',
	MultiColor			= 'multi_color'
}
